define(
  'modules/spin-loader',
  [
    'jquery',
    'velocity',
    'modules/utils',
    'spin/jeeliz/dist/jeelizFaceFilter',
    'spin/jeeliz/helpers/JeelizResizer',
    'spin/head-tracker',
    'spin/video-rotator',
    'spin/audio-engine-low'
  ],
  function (
    $,
    velocity,
    M_Utils
  ) {
    'use strict';

    var state = {
      isVisible: false,
      isFirstRun: true
    };

    var settings
      , headTracker
      , audioEngine
      , videoRotator;

    function init (config) {

      // has to use window global due to rollup
      settings = window.settings = {

          config: config,
          manifest: config.manifest,

          interactiveVideos: {
            "exterior_features": {
              audio: "external",
              url: config.manifest.assets['exterior_features'].src,
              initialTime: 0.6030442035029192,
              images: config.assetPath + "frames/450e/image-xxxx.jpg",
              poster: config.assetPath + "frames/450e/image-0451.jpg",
              background: config.manifest.backgroundImages['exterior_features'],
              imageCount: 749,
              speedMultiplier: 1,
              loop: true,
              hotspots: [
                { x:0, y:-1000, z:0, normal: { x:-1, y:0, z:0 }, css:"c-nx-spin__hotspot--navigation", type:"navigation", name: "exterior - you must always define this first", action:{ destination:"exterior", source:"interior" } },
                { x:0, y:-1000, z:0, normal: { x:-1, y:0, z:0 }, css:"c-nx-spin__hotspot--navigation", type:"navigation", name: "exterior - you must always define this first", action:{ destination:"exterior", source:"interior" } },
                { x:1, y:-0.5, z:-0.1, normal: { x:-1, y:0, z:0 }, css:"c-nx-spin__hotspot--navigation", type:"navigation", name: "interior - you must always define this second", action:{ destination:"interior", source:"exterior" } },
                { x:-1, y:-0.5, z:-0.1, normal: { x:1, y:0, z:0 }, css:"c-nx-spin__hotspot--navigation", type:"navigation", name: "interior - you must always define this second", action:{ destination:"interior", source:"exterior" } },
                { x:0.4, y:0.7, z:1.8, normal: { x:0, y:0, z:-1 }, css:"c-nx-spin__hotspot--story", type:"story", name:"front", action:{ destination:"storyDesign" } },
                { x:0.8, y:0.0, z:-1.8, normal: { x:0, y:0, z:1 }, css:"c-nx-spin__hotspot--story", type:"story", name:"back", action:{ destination:"storyPowertrain" } },
                { x:-0.9, y:1.06, z:1.08, normal: { x:1, y:0, z:0 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"wheels", action:{ destination:"featureWheels" } },
                { x:-1, y:-1, z:0.4, normal: { x:1, y:0, z:0 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"wing mirror", action:{ destination:"featureDesign" } },
                { x:-0.8, y:0.0, z:1.7, normal: { x:0, y:0, z:-1 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"front headlight", action:{ destination:"featureFrontStance" } },
                { x:0.9, y:-0.6, z:-1.25, normal: { x:-1, y:0, z:0 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"charging point", action:{ destination:"featurePlugInPoint" } },
                { x:-0.8, y:-0.6, z:-1.25, normal: { x:1, y:0, z:0 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"charging point", action:{ destination:"featurePlugInPoint" } },
                { x:-0.8, y:-0.65, z:-1.8, normal: { x:0, y:0, z:1 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"back light", action:{ destination:"featureRearStance" } },
                { x:0.0, y:0.0, z:-1.8, normal: { x:0, y:0, z:1 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"boot", action:{ destination:"featureBootCapacity" } },
                { x:0, y:-1.9, z:-0.2, normal: { x:0, y:1, z:0 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"roof", action:{ destination:"featureSunroof" } }
              ]
            },
            "interior_features": {
              audio: "internal",
              url: config.manifest.assets['interior_features'].src,
              initialTime: 0.3225020850708924,
              images: config.assetPath + "frames/450i/image-xxxx.jpg",
              poster: config.assetPath + "frames/450i/image-0241.jpg",
              background: config.manifest.backgroundImages['interior_features'],
              imageCount: 749,
              speedMultiplier: 1,
              loop: true,
              hotspots: [
                { x:5, y:0, z:-0.5, normal: { x:-1, y:0, z:0 }, css:"c-nx-spin__hotspot--navigation", type:"navigation", name: "exterior - you must always define this first", action:{ destination:"exterior", source:"interior" } },
                { x:-5, y:0, z:6, normal: { x:1, y:0, z:0 }, css:"c-nx-spin__hotspot--navigation", type:"navigation", name: "exterior - you must always define this first", action:{ destination:"exterior", source:"interior" } },
                { x:1, y:-1000, z:0, normal: { x:-1, y:0, z:0 }, css:"c-nx-spin__hotspot--navigation", type:"navigation", name: "interior - you must always define this second", action:{ destination:"interior", source:"exterior" } },
                { x:1, y:-1000, z:0, normal: { x:-1, y:0, z:0 }, css:"c-nx-spin__hotspot--navigation", type:"navigation", name: "interior - you must always define this second", action:{ destination:"interior", source:"exterior" } },
                { x:7.5, y:0, z:2, normal: { x:-0.7, y:0, z:-0.7 }, css:"c-nx-spin__hotspot--story", type:"story", name:"driving signature", action:{ destination:"storyDrivingSignature" } },
                { x:5, y:-2, z:5, normal: { x:0, y:0, z:-1 }, css:"c-nx-spin__hotspot--story", type:"story", name:"media display 2", action:{ destination:"storyMediaDisplay" } },
                { x:3.5, y:-3, z:5, normal: { x:0, y:0, z:-1 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"media display", action:{ destination:"featureMediaDisplay" } },
                { x:5, y:2.7, z:5, normal: { x:0, y:0, z:-1 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"transmission", action:{ destination:"featureAutomaticTransmission" } },
                { x:3, y:2.7, z:5, normal: { x:0, y:0, z:-1 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"charging", action:{ destination:"featureWirelessCharging" } },
                { x:7.5, y:-1, z:3, normal: { x:-0.7, y:0, z:-0.7 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"steering wheel", action:{ destination:"featureSteeringWheel" } },
                { x:-2, y:-2, z:4, normal: { x:0.0, y:0, z:-1 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"craftsmanship", action:{ destination:"featureCraftsmanshipFront" } },
                { x:-3.5, y:1, z:-3, normal: { x:1.0, y:0, z:0 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"space", action:{ destination:"featureSpace" } },
                { x:-5, y:0.8, z:-2, normal: { x:1.0, y:0, z:0 }, css:"c-nx-spin__hotspot--feature", type:"feature", name:"craftsmanship 2", action:{ destination:"featureCraftsmanshipBack" } }
              ]
            },
            "interior_spinA": {
                audio:"internal",
                url: config.manifest.assets['interior_spinA'].src,
                initialTime: 0.34286905754795666,
                images: config.assetPath + "frames/450i-pan/image-xxxx.jpg",
                poster: config.assetPath + "frames/450i-pan/image-0054.jpg",
                background: config.manifest.backgroundImages['interior_spinA'],
                imageCount: 158,
                speedMultiplier: 2,
                loop:false
            },
            "interior_spinB": {
                audio:"internal",
                url: config.manifest.assets['interior_spinB'].src,
                initialTime: 0.31534612176814014,
                images: config.assetPath + "frames/350i-pan/image-xxxx.jpg",
                poster: config.assetPath + "frames/350i-pan/image-0120.jpg",
                background: config.manifest.backgroundImages['interior_spinB'],
                imageCount: 382,
                speedMultiplier: 2,
                loop:false
            },
            "exterior_spinA": {
                audio:"external",
                url: config.manifest.assets['exterior_spinA'].src,
                initialTime: 0.5464553794829023,
                images: config.assetPath + "frames/450e-doors/image-xxxx.jpg",
                poster: config.assetPath + "frames/450e-doors/image-0409.jpg",
                background: config.manifest.backgroundImages['exterior_spinA'],
                imageCount: 749,
                speedMultiplier: 1,
                loop:true
            },
            "exterior_spinB": {
                audio:"external",
                url: config.manifest.assets['exterior_spinB'].src,
                initialTime: 0.09157631359466221,
                images: config.assetPath + "frames/450e-boot/image-xxxx.jpg",
                poster: config.assetPath + "frames/450e-boot/image-0068.jpg",
                background: config.manifest.backgroundImages['exterior_spinB'],
                imageCount: 749,
                speedMultiplier: 1,
                loop:true
            }
          },

          initialVideoRotatorSettings: {
              container: document.getElementById('video-rotator-container')
          },

          initialAudioEngineSettings: { },

          initialHeadTrackerSettings: {
              neuralNetPath: config.appRoot + config.scriptRoot + '/spin/jeeliz/nets/',
              canvasID: 'head-tracker-canvas'
          },

          eventDispatcher: window,
          isMobile: M_Utils.getIsMobile(),
          isIE: M_Utils.isIE,
          headTrackingAvailable: false,
          useHeadTracking: false,
          headTrackingUserDisabled: false,
          volume: 1,

          debugMode: false,
          devMode: document.location.hostname.indexOf("localhost") !== -1 // used by danny (eg no lexus server present)
      };

      headTracker = new HeadTracker( settings, settings.initialHeadTrackerSettings );
      audioEngine = new AudioEngine( settings, settings.initialAudioEngineSettings );
      videoRotator = new VideoRotator( settings, settings.initialVideoRotatorSettings );
    }

    function spinStart (view, subView, sourceImage, onSpinStarted, isInitialLoad) {
      var videoId = view + '_' + subView;
      var video = settings.manifest.assets[videoId].src;
      var audio1 = settings.manifest.audio[view + '_1'].src;
      var audio2 = settings.manifest.audio[view + '_2'].src;
      var audio3 = settings.manifest.audio[view + '_3'].src;
      var background = settings.manifest.backgroundImages[videoId];
      var assetsRequired = [
        settings.interactiveVideos[videoId].url,
        settings.interactiveVideos[videoId].poster
      ];
      var initialOpacity = (sourceImage) ? 0.2 : 0;
      var duration = (state.isFirstRun) ? 0 : 500;

      state.isFirstRun = false;

      M_Utils.getBlobs([ video, audio1, audio2, audio3 ], function (blobs) {

        var videoBlob = blobs[video]
          , audioSet = [ blobs[audio1] ];

        enableSpin();

        M_Utils.triggerEvent( 'SPIN_ASSETS_LOADED' );

        $(settings.initialVideoRotatorSettings.container).velocity(
          { opacity: initialOpacity },
          {
            duration: duration,
            progress: function (elements, complete, remaining, start, tweenValue) {      
              M_Utils.triggerEvent( 'AUDIOSETFADE', { fade: 1-complete });
            },
            complete: function () {
              M_Utils.getBlobs(assetsRequired, function (blobs2) {
                M_Utils.triggerEvent( 'VIDEOROTATORLOAD', { blob: videoBlob, data: settings.interactiveVideos[videoId], sourceImage: sourceImage, destinationImage: blobs2[1] });
                M_Utils.triggerEvent( 'AUDIOPLAY3DSET', { set: audioSet, audioController: videoRotator });

                window.setTimeout( function(){
                  $(settings.initialVideoRotatorSettings.container).velocity(
                    { opacity: 1 },
                    { 
                      duration: 1000,
                      progress: function(elements, complete, remaining, start, tweenValue) {
                        if (isInitialLoad) {
                          return;
                        }
                        M_Utils.triggerEvent( 'AUDIOSETFADE', { fade: complete });
                      }
                    }
                  );
                }, 300);

                M_Utils.setSelectedView(view);
                M_Utils.setSelectedSubView(subView);

                if (typeof onSpinStarted == 'function') {
                  onSpinStarted();
                }
              });
            }
          }
        );
      });
    }

    function enableSpin () {
      if ( !state.isVisible ) {
        state.isVisible = true;

        $(settings.initialVideoRotatorSettings.container).show();
      }
    }

    function headTrackingEnable () {
      settings.headTrackingAvailable = true;
      settings.headTrackingUserDisabled = false;

      headTrackingStart();
    }

    function headTrackingDisable () {
      settings.headTrackingUserDisabled = true;

      headTrackingStop();
    }

    function headTrackingStart () {
      if ( !settings.headTrackingUserDisabled ) {
        settings.useHeadTracking = true;

        M_Utils.triggerEvent( 'TRACKINGSTART', {});
      }
    }

    function headTrackingStop () {
      settings.useHeadTracking = false;
      M_Utils.triggerEvent( 'TRACKINGSTOP', {});
    }

    function mute () {
      settings.volume = 0;
    }

    function unmute () {
      settings.volume = 1;
    }

    return {
      init: init,
      spinStart: spinStart,
      headTrackingEnable: headTrackingEnable,
      headTrackingDisable: headTrackingDisable,
      headTrackingStart: headTrackingStart,
      headTrackingStop: headTrackingStop,
      mute: mute,
      unmute: unmute
    }
});
